import React from 'react';
import { LegacyRouteMapper, Logger } from 'services';

export const SINGLETONS = {
  legacyRouteMapper: React.createContext(
    new LegacyRouteMapper(window.location.origin)
  ),
  logger: React.createContext(new Logger())
};
